import Colour from 'components/utils/Colour'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import { getThemeClassName } from 'lib/theme/themeUtils'
import TextButton from 'LuxKit/Button/TextButton'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import React from 'react'
import { LUX_PLUS_SIA_MASTERCARD_FLIGHTS_URL } from '../constants/luxPlusSingaporeAirlinesMastercardTakeoverConstants'
import SolidPlaneIcon from 'LuxKit/Icons/solid/SolidPlaneIcon'

interface Props {
  withCta?: boolean
}

function LuxPlusSingaporeAirlinesMastercardOfferBanner({ withCta }: Props) {
  const bannerCopy = 'members earn up to $300 bonus LE Credit per person on eligible Singapore Airlines flights. T&Cs apply.'
  const ctaUrl = LUX_PLUS_SIA_MASTERCARD_FLIGHTS_URL
  const ctaText = 'View details'

  return (
    <Group
      direction="horizontal"
      gap={12}
      verticalAlign="center"
      className={getThemeClassName({ mobile: 'inverse' })}
    >
      <SolidPlaneIcon size={48} />
      <BodyText variant="large">
        <b>LuxPlus<Colour value="highlight-lux-plus">+</Colour></b> {bannerCopy}
        {withCta && (
          <CSSBreakpoint as="span" max="mobile">
            {'  '}<TextLink
              to={ctaUrl}
              wrap="no-wrap"
            >
              {ctaText}
            </TextLink>
          </CSSBreakpoint>
        )}
      </BodyText>
      {withCta && (
        <CSSBreakpoint min="tablet" className={getThemeClassName({ mobile: 'inverse' })}>
          <TextButton
            kind="secondary"
            size="small"
            to={ctaUrl}
          >
            {ctaText}
          </TextButton>
        </CSSBreakpoint>
      )}
    </Group>
  )
}

export default LuxPlusSingaporeAirlinesMastercardOfferBanner
